import { useEffect, useState } from "react";
import { Modal } from "../../../../components";
import { activarJefe } from "../handlers";

export default function ActivarJefe(props) {
  const [rta, setRta] = useState({
    data: null,
    error: null,
    loading: false,
  });

  useEffect(() => {
    if (rta.data && rta.error == null && !rta.loading) {
      props.actualizarJefes();
      props.setAbrir(false);
    }
  }, [rta]);

  return (
    <Modal
      onHide={props.setAbrir}
      show={props.abrir}
      title={() => {
        return "¿Activar Jefe de Comuna?";
      }}
      loading={rta.loading}
    >
      <div className="d-flex justify-content-center gap-2">
        <button
          className="btn btn-sm btn-success d-flex"
          onClick={() => {
            activarJefe(rta, setRta, props.jefeId, props.barrio_id);
          }}
          disabled={rta.loading}
        >
          Activar{" "}
          {rta.loading && (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          )}
        </button>
        <button
          className="btn btn-sm btn-danger"
          onClick={() => {
            props.setAbrir(false);
          }}
          disabled={rta.loading}
        >
          Cancelar
        </button>
      </div>
    </Modal>
  );
}
